import type { OptionDefinition } from "../types.ts";

export const cameraGeneralOptions: OptionDefinition[] = [
  {
    key: "debug",
    type: "boolean",
    default: false,
    label: "Debug",
    tab: "camera",
  },
  {
    key: "enableCamera",
    type: "boolean",
    default: true,
    label: "Enable Camera",
    tab: "camera",
  },
  {
    key: "cameraFlipHorizontal",
    type: "boolean",
    default: false,
    label: "Flip Camera Horizontal",
    tab: "camera",
  },
  {
    key: "hideCamera",
    type: "boolean",
    default: false,
    label: "Hide Camera (skips segmentation)",
    tab: "camera",
  },
  {
    key: "cameraRotation",
    type: "select",
    default: "0",
    label: "Camera Rotation",
    tab: "camera",
    options: [
      { value: "0", label: "None" },
      { value: "90", label: "90°" },
      { value: "180", label: "180°" },
      { value: "270", label: "270°" },
    ],
  },
  {
    key: "segmentation",
    type: "boolean",
    default: false,
    label: "Segmentation",
    tab: "camera",
  },
  {
    key: "resolution",
    type: "select",
    default: "low",
    label: "Resolution",
    tab: "camera",
    options: [
      { value: "low", label: "Low" },
      { value: "medium", label: "Medium" },
      { value: "high", label: "High" },
    ],
  },
  {
    key: "frameRate",
    type: "select",
    default: "15",
    label: "Frame Rate",
    tab: "camera",
    options: [
      { value: "15", label: "15 fps" },
      { value: "30", label: "30 fps" },
      { value: "max", label: "Max" },
    ],
  },
  {
    key: "renderHandsOverlay",
    type: "boolean",
    default: false,
    label: "Show Hands Overlay",
    tab: "camera",
  },
  {
    key: "renderHandsColor",
    type: "color",
    default: "#00FF00",
    label: "Hands Overlay Color",
    tab: "camera",
    dependsOn: "renderHandsOverlay",
  },
  {
    key: "renderHandsOpacity",
    type: "range",
    default: 1,
    min: 0,
    max: 1,
    step: 0.05,
    label: "Hands Overlay Opacity",
    tab: "camera",
    dependsOn: "renderHandsOverlay",
  },
  {
    key: "renderPoseOverlay",
    type: "boolean",
    default: false,
    label: "Show Pose Overlay",
    tab: "camera",
  },
  {
    key: "renderPoseColor",
    type: "color",
    default: "#00FF00",
    label: "Pose Overlay Color",
    tab: "camera",
    dependsOn: "renderPoseOverlay",
  },
  {
    key: "renderPoseOpacity",
    type: "range",
    default: 1,
    min: 0,
    max: 1,
    step: 0.05,
    label: "Pose Overlay Opacity",
    tab: "camera",
    dependsOn: "renderPoseOverlay",
  },
  {
    key: "emitRawHandData",
    type: "boolean",
    default: false,
    label: "Emit Raw Hand Data",
    tab: "camera",
  },
  {
    key: "emitRawPoseData",
    type: "boolean",
    default: false,
    label: "Emit Raw Pose Data",
    tab: "camera",
  },
  {
    key: "debugClench",
    type: "boolean",
    default: false,
    label: "Debug Clench",
    tab: "camera",
  },
];
